import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { APP_ENDPOINT, ASSET_PREFIX } from "utils/constants";

const SocialOption = {
  facebook: {
    icon: `${ASSET_PREFIX}/images/account/referrals/facebook.svg`,
    href: (referralLink: string, text: string) =>
      `https://www.facebook.com/dialog/share?app_id=256975402191022&display=popup&href=${encodeURIComponent(
        referralLink
      )}&quote=${text}`,
  },
  whatsapp: {
    icon: `${ASSET_PREFIX}/images/account/referrals/whatsapp.svg`,
    href: (referralLink: string, text: string) =>
      `whatsapp://send?text=${encodeURIComponent(`${text} ${referralLink}`)}`,
  },
  email: {
    icon: `${ASSET_PREFIX}/images/account/referrals/email-icon.svg`,
    href: (referralLink: string, text: string) =>
      `mailto:?subject=${encodeURIComponent(
        'Check Out DAYMADE!'
      )}&body=${encodeURIComponent(`${text} ${referralLink}`)}`,
  },
  linkedin: {
    icon: `${ASSET_PREFIX}/images/account/referrals/linkedin.svg`,
    href: (referralLink: string) =>
      `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        referralLink
      )}`,
  },
};

const SocialOptions = Object.keys(SocialOption);

const SocialReferralButtons = observer(() => {
  const { currentUser } = useUserStore();
  const referralId = currentUser?.referralId;
  const impactLink = `https://${APP_ENDPOINT}/impact/${referralId}`;
  const text = `I've planted ${
    currentUser?.treesPlanted === 1
      ? '1 tree'
      : `${currentUser?.treesPlanted.toLocaleString()} trees`
  } with DAYMADE!`;
  return (
    <div className="container">
      {SocialOptions.map((id) => {
        const option = SocialOption[id as keyof typeof SocialOption];
        return (
          <Link
            key={id}
            href={option.href ? option.href(impactLink, text) : '#'}
          >
            <a
              target="_blank"
              className="option"
            >
              <img src={option.icon} />
            </a>
          </Link>
        );
      })}

      <style jsx>{`
        .container {
          display: flex;
          justify-content: space-between;
        }

        .option {
          margin: 0 0.5em;
          line-height: 0;
          cursor: pointer;
        }

        .option img {
          margin: 0.6em auto;
          height: 30px;
          filter: brightness(30%) saturate(100%);
        }
      `}</style>
    </div>
  );
});

export default SocialReferralButtons;